import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NewsSubscribe() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            SUBSCRIBE
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('news.subscribe.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            Stay Informed
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-5"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto">
            {t('news.subscribe.desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="card-glow bg-background-100/60 border border-background-200/60 p-6 text-center">
            <div className="w-10 h-10 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-mail-line text-accent-500 text-lg"></i>
            </div>
            <h3 className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium mb-2">
              {t('news.related.0.title')}
            </h3>
            <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-4">
              {t('news.related.0.description')}
            </p>
            <Link
              to="/brochure"
              className="inline-flex items-center gap-2 text-accent-500 hover:text-accent-400 text-[14px] tracking-[0.06em] transition-colors whitespace-nowrap"
            >
              {t('news.subscribe.btn')}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>

          <div className="card-glow bg-background-100/60 border border-background-200/60 p-6 text-center">
            <div className="w-10 h-10 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-customer-service-2-line text-accent-500 text-lg"></i>
            </div>
            <h3 className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium mb-2">
              {t('news.related.1.title')}
            </h3>
            <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-4">
              {t('news.related.1.description')}
            </p>
            <Link
              to="/consultation"
              className="inline-flex items-center gap-2 text-accent-500 hover:text-accent-400 text-[14px] tracking-[0.06em] transition-colors whitespace-nowrap"
            >
              {t('news.related.viewMore')}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>

          <div className="card-glow bg-background-100/60 border border-background-200/60 p-6 text-center">
            <div className="w-10 h-10 mx-auto mb-4 flex items-center justify-center">
              <i className="ri-phone-line text-accent-500 text-lg"></i>
            </div>
            <h3 className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium mb-2">
              {t('news.related.2.title')}
            </h3>
            <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-4">
              {t('news.related.2.description')}
            </p>
            <a
              href="tel:0368244086"
              className="inline-flex items-center gap-2 text-accent-500 hover:text-accent-400 text-[14px] tracking-[0.06em] transition-colors whitespace-nowrap"
            >
              03-6824-4086
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
